import BecomeExpertTermsAndConditionsComponent from "../../components/become-expert/become-expert-terms-and-conditions";

const BecomeExpertTermsAndConditionsPage = () => <BecomeExpertTermsAndConditionsComponent />

export default BecomeExpertTermsAndConditionsPage;